// extracted by mini-css-extract-plugin
module.exports = {"container":"displayStyleSwitch_container__q_MyJ","input":"displayStyleSwitch_input__q0R5V","span":"displayStyleSwitch_span__bVnKe"};